module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_05_pub#pub"
    }
  }, [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_06_ack#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_08_ch1#ch1"
    }
  }, [_c('strong', [_vm._v("1. Introduction: Fossils and Phylogeny")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_08_ch1#ch1.1"
    }
  }, [_vm._v("Sources of Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_08_ch1#ch1.2"
    }
  }, [_vm._v("Methods of Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_08_ch1#ch1.3"
    }
  }, [_vm._v("Classification")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_08_ch1#ch1.4"
    }
  }, [_vm._v("Vertebrates in Geological Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_09_ch2#ch2"
    }
  }, [_c('strong', [_vm._v("2. Evolution: Patterns and Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_09_ch2#ch2.1"
    }
  }, [_vm._v("The Process of Evolution")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226220635_09_ch2#ch2.2"
    }
  }, [_vm._v("Evolutionary Phenomena")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_10_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. The Basic Vertebrate Body Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_11_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. The Earliest Fossil Vertebrates: The Ostracoderms")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_12_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. The First Jawed Fishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_12_ch5#ch5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acanthodians")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_12_ch5#ch5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Placoderms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_13_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. Early Bony and Cartilaginous Fishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_13_ch6#ch6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Osteichthyans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_13_ch6#ch6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chondrichthyans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_14_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7. Later Cartilaginous Fishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_15_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8. Later Bony Fishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_16_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9. Designs for Land Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_17_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10. The Amphibians")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_18_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11. Early Reptiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_19_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12. The Great Reptile Land Radiations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13. Lesser Land and Amphibious Radiations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhynchosaurs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turtles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lizards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amphisbaenians")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_20_ch13#ch13.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sphenodon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_21_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14. Reptile Designs for Marine Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_21_ch14#ch14.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ichthyosaurs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_21_ch14#ch14.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plesiosaurs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_21_ch14#ch14.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mosasaurs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_21_ch14#ch14.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Aquatic Reptiles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_22_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15. Reptile Designs for Flight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_22_ch15#ch15.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pterosaurs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_22_ch15#ch15.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birds")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_23_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16. The Origin of Mammals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_24_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17. Diversity of Mammalian Design")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_24_ch17#ch17.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skulls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_24_ch17#ch17.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jaws")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_24_ch17#ch17.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teeth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_24_ch17#ch17.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Limbs")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_25_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("18. The Evolutionary Radiations of the Mammals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_26_glo#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_27_add#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Readings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_28_fig#fig",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226220635_29_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45759b46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226220635_04_toc.vue
// module id = 72
// module chunks = 0